<template>
  <div class="menu-box">
    <div class="menu-box-header">
      <span class="menu-box-title">{{title}}</span>
      <div class="menu-box-icon" @click="clickButtonMenu()">
        <slot name="icon"></slot>
      </div>
    </div>


    <div class="menu-scrollbar">
      <div class="menu-box-content" ref="menuContent">
        <slot></slot>
      </div>
      <div class="menu-box-pene" ref="scrollbar" @mousemove="sliderClick">
        <div class="menu-box-slider" :style="transform" ></div>
      </div>
    </div>
  </div>
</template>



<script>

    import { mapState } from 'vuex';
    export default {
        props: ['title'],
        computed: {
            ...mapState({
                showRightWindow: state => state.showRightWindow
            })
        },
        data() {
            return {
                transform: {transform: 'translate(0px, 0px)'},
            }
        },
        watch: {

        },



        methods: {
            clickButtonMenu() {
                this.$emit('clickButtonMenu');
            },


            sliderClick(evt) {

                if (evt.buttons == 1) {
                    let content = this.$refs.scrollbar.clientHeight;
                    let menu = this.$refs.content.clientHeight;

                    let maxPoint = content - 30;
                    let maxTransform = content - 60;

                    let topScroll = this.$refs.menuContent.scrollTop;

                    if (evt.target.className == 'menu-box-pene') {
                        let point = evt.layerY > maxPoint ? maxPoint : evt.layerY;
                        topScroll = point - 30 > maxTransform ? maxTransform : point - 30;
                    } else {
                        topScroll *= ((content - 60)/(menu - content));
                        let delta = evt.layerY - 30;
                        topScroll = topScroll + delta > maxTransform ? maxTransform : topScroll + delta;
                        if (topScroll < 0) {
                            topScroll = 0;
                        }
                        let top = (topScroll * (menu - content))/(content - 60);
                        this.$refs.menuContent.scrollTop = top;
                    }
                    //this.transform = {transform: 'translate(0px, ' + topScroll + 'px)'};

                }
            },

            handleScroll(evt) {
                if (this.$refs.scrollbar.clientHeight > 60) {
                    let top = (evt.target.scrollTop / evt.target.scrollTopMax) * (this.$refs.scrollbar.clientHeight - 60);
                    this.transform = { transform: 'translate(0px, ' + top + 'px)'};
                } else {
                    this.transform = { transform: 'translate(0px, 0px)'};
                }
            },

            footerScroll() {

                let footerBottom =window.innerHeight + window.scrollY - document.body.clientHeight;
                if (footerBottom > 0) {
                    footerBottom =0;
                }
                let menuBottom = 80 + footerBottom;
                if (menuBottom < 0) {
                    menuBottom = 0;
                }

                this.bottom = menuBottom;
            }


        },
        mounted: function () {
            this.$refs.menuContent.addEventListener('scroll', this.handleScroll);
            window.addEventListener('scroll', this.footerScroll);
            window.addEventListener('resize', this.footerScroll);

        },
        beforeDestroy: function () {
            this.$refs.menuContent.addEventListener('scroll', this.handleScroll);
            window.removeEventListener('scroll', this.footerScroll);
            window.removeEventListener('resize', this.footerScroll);
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/layout/src/navigation/MenuBox.vue